import React from 'react'

const TrilogyLogoBlk = ({ height, width }) =>
  <svg version="1.1" id="tilogylogoblk" xmlns="http://www.w3.org/2000/svg" width={ width } height={ height } x="0px" y="0px" aria-labelledby="tilogylogoblkTitle" viewBox="0 0 415.8 135.5">
    <title id="tilogylogoblkTitle">Trilogy Logo</title>
    <polygon className="blue-icon" points="158.3,4.6 86.5,129 14.6,4.6 "/>
    <polygon className="dark-blue-fill" points="168.8,54.1 86.5,129 86.5,4.6 "/>
    <polygon className="light-blue-fill" points="3.7,54.1 86.6,4.6 86.6,129 "/>
    <g>
      <path className="white-fill" d="M117,49.3H95.5v44.5H77.8V49.3H56.3V35H117V49.3z"/>
    </g>
    <g>
      <path d="M192.2,42.6h-12.4v-5.9h31.6v5.9h-12.4v31.8h-6.9V42.6z"/>
      <path d="M216.5,36.7h12.2c4.1,0,6,0.3,7.6,1.1c3.8,1.7,6.2,5.3,6.2,10.3c0,4.5-2.4,8.7-6.4,10.3v0.1c0,0,0.5,0.5,1.3,1.9l7.8,14.1
      h-7.7l-7.5-14.1h-6.6v14.1h-6.9V36.7z M229.5,54.4c3.7,0,6-2.2,6-6c0-3.6-1.5-5.8-6.9-5.8h-5.2v11.8H229.5z"/>
      <path d="M251.4,36.7h6.9v37.7h-6.9V36.7z"/>
      <path d="M267.9,36.7h6.9v31.8H291v5.9h-23.2V36.7z"/>
      <path d="M312.8,36c11.1,0,19.5,8.5,19.5,19.2c0,11.1-8.4,19.8-19.5,19.8c-11.1,0-19.5-8.7-19.5-19.8C293.3,44.5,301.7,36,312.8,36z
        M312.8,68.8c6.9,0,12.4-5.7,12.4-13.5c0-7.4-5.5-13-12.4-13c-6.9,0-12.4,5.5-12.4,13C300.3,63,305.9,68.8,312.8,68.8z"/>
      <path d="M356.1,36c9.2,0,14,4.8,14,4.8l-3.4,5.1c0,0-4-3.6-10-3.6c-8.5,0-13,5.8-13,13c0,8.2,5.6,13.5,12.7,13.5
      c5.7,0,9.5-3.9,9.5-3.9v-4.4h-5.8v-5.9h12v19.9h-5.8v-1.8c0-0.8,0.1-1.6,0.1-1.6h-0.1c0,0-3.9,4-10.9,4c-9.9,0-18.5-7.7-18.5-19.6
      C336.7,44.5,344.9,36,356.1,36z"/>
      <path d="M387.3,58.6l-12.5-22h7.8l5.9,11.1c1.2,2.3,2.2,5.1,2.3,5h0.1c0,0,1.1-2.7,2.3-5l5.8-11.1h7.8l-12.5,22v15.8h-6.9V58.6z"/>
    </g>
    <g>
      <path d="M184.9,82.3h8.8v2.3h-6.1v3.8h4.9v2.3h-4.9v3.9h6.4V97h-9.1V82.3z"/>
      <path d="M196.8,82.3h5c4.5,0,7.5,2.7,7.5,7.3c0,4.6-3,7.4-7.5,7.4h-5V82.3z M201.7,94.7c3,0,4.9-1.8,4.9-5.1c0-3.3-1.9-5-4.9-5
      h-2.2v10.1H201.7z"/>
      <path d="M211.9,82.3h2.7v9.4c0,2,1.3,3.1,3.2,3.1s3.3-1.1,3.3-3.1v-9.4h2.7v9.4c0,3.3-2.4,5.5-5.9,5.5c-3.6,0-5.9-2.2-5.9-5.5V82.3
      z"/>
      <path d="M233.7,82.1c3.6,0,5.4,2,5.4,2l-1.3,2c0,0-1.7-1.5-4-1.5c-3.1,0-4.9,2.3-4.9,5c0,2.8,1.9,5.2,4.9,5.2
      c2.5,0,4.3-1.9,4.3-1.9l1.4,1.9c0,0-2,2.4-5.8,2.4c-4.5,0-7.6-3.3-7.6-7.6C226.2,85.3,229.4,82.1,233.7,82.1z"/>
      <path d="M249.3,93.2h-5.1l-1.2,3.8h-2.7l5.2-14.7h2.8l5.2,14.7h-2.7L249.3,93.2z M246.7,84.9c0,0-0.3,1.4-0.6,2.3l-1.3,3.9h3.8
      l-1.3-3.9C247,86.3,246.7,84.9,246.7,84.9L246.7,84.9z"/>
      <path d="M257.3,84.6h-4.8v-2.3h12.3v2.3H260V97h-2.7V84.6z"/>
      <path d="M266.7,82.3h2.7V97h-2.7V82.3z"/>
      <path d="M279.7,82.1c4.3,0,7.6,3.3,7.6,7.5c0,4.3-3.3,7.7-7.6,7.7c-4.3,0-7.6-3.4-7.6-7.7C272.1,85.3,275.4,82.1,279.7,82.1z
        M279.7,94.8c2.7,0,4.8-2.2,4.8-5.2c0-2.9-2.1-5-4.8-5s-4.8,2.1-4.8,5C274.9,92.6,277,94.8,279.7,94.8z"/>
      <path d="M290,82.3h2.7l5.6,8.5c0.6,0.8,1.2,2.3,1.2,2.3h0c0,0-0.1-1.4-0.1-2.3v-8.5h2.6V97h-2.6l-5.6-8.4c-0.6-0.8-1.2-2.3-1.2-2.3
      h0c0,0,0.1,1.4,0.1,2.3V97H290V82.3z"/>
      <path d="M311,93.2c0,0,1.6,1.5,3.7,1.5c1.1,0,2.1-0.6,2.1-1.8c0-2.6-6.9-2.2-6.9-6.7c0-2.4,2.1-4.3,4.9-4.3c2.9,0,4.4,1.6,4.4,1.6
      l-1.2,2.2c0,0-1.4-1.3-3.2-1.3c-1.2,0-2.2,0.7-2.2,1.8c0,2.6,6.9,2,6.9,6.6c0,2.3-1.8,4.3-4.8,4.3c-3.3,0-5.1-2-5.1-2L311,93.2z"/>
      <path d="M322.1,82.3h8.8v2.3h-6.1v3.8h4.9v2.3h-4.9v3.9h6.4V97h-9.1V82.3z"/>
      <path d="M334,82.3h4.7c1.6,0,2.3,0.1,3,0.4c1.5,0.7,2.4,2.1,2.4,4c0,1.8-0.9,3.4-2.5,4v0c0,0,0.2,0.2,0.5,0.7l3,5.5h-3l-2.9-5.5
      h-2.6V97H334V82.3z M339.1,89.2c1.4,0,2.3-0.8,2.3-2.3c0-1.4-0.6-2.3-2.7-2.3h-2v4.6H339.1z"/>
      <path d="M345.6,82.3h2.9l3.2,9.6c0.3,0.8,0.5,2.1,0.6,2.1h0c0,0,0.3-1.3,0.6-2.1l3.2-9.6h2.8L353.6,97H351L345.6,82.3z"/>
      <path d="M360.8,82.3h2.7V97h-2.7V82.3z"/>
      <path d="M373.7,82.1c3.6,0,5.4,2,5.4,2l-1.3,2c0,0-1.7-1.5-4-1.5c-3.1,0-4.9,2.3-4.9,5c0,2.8,1.9,5.2,4.9,5.2
      c2.5,0,4.3-1.9,4.3-1.9l1.4,1.9c0,0-2,2.4-5.8,2.4c-4.5,0-7.6-3.3-7.6-7.6C366.2,85.3,369.4,82.1,373.7,82.1z"/>
      <path d="M382,82.3h8.8v2.3h-6.1v3.8h4.9v2.3h-4.9v3.9h6.4V97H382V82.3z"/>
      <path d="M394.2,93.2c0,0,1.6,1.5,3.7,1.5c1.1,0,2.1-0.6,2.1-1.8c0-2.6-6.9-2.2-6.9-6.7c0-2.4,2.1-4.3,4.9-4.3
      c2.9,0,4.4,1.6,4.4,1.6l-1.2,2.2c0,0-1.4-1.3-3.2-1.3c-1.2,0-2.2,0.7-2.2,1.8c0,2.6,6.9,2,6.9,6.6c0,2.3-1.8,4.3-4.8,4.3
      c-3.3,0-5.1-2-5.1-2L394.2,93.2z"/>
    </g>
  </svg>

export default TrilogyLogoBlk
